










import Vue from 'vue'

import selectSearchable from '@/components/controls/select/select-searchable/select-searchable.vue'
import { DefaultListModel } from '@/components/controls/select/select-searchable/types'

import { TenderWebApi } from '@/api/tenderApi'

import { UnitsModel } from '@/types/common'

export default Vue.extend({
    name: 'unit-selector',
    components: {
        selectSearchable
    },
    props: {
        item: Object as () => UnitsModel
    },
    mounted() {
        this.currentValue.Name = this.item.UnitShortName
        this.currentValue.Value = this.item.UnitCode
    },
    data() {
        return {
            list: [] as UnitsModel[],
            keyword: this.item.UnitName,
            currentValue: {
                Name: 'Выбрать',
                Value: '',
                Selected: false
            } as DefaultListModel
        }
    },
    methods: {
        async search(keyword: string) {

            //сделать тротлинг

            this.keyword = keyword;
            
            const { data } = await TenderWebApi.GetUnitsByKeyword(escape(keyword));

            this.list = data.slice(0, 25);
        },
        select(data: DefaultListModel) {
            this.currentValue = data;

            const currentItem = this.list.find((item) => item.Code === data.Value)

            if(currentItem && currentItem.ShortName) {
                this.currentValue.Name = currentItem.ShortName;
            }

            this.$emit('select', currentItem)
        }
    },
    computed: {
        unitsList(): DefaultListModel[] {
            const list = this.list.map((item) => {
                return {
                    Name: item.Name ? item.Name : 'Неизвестно',
                    Value: item.Code ? item.Code : '',
                    Selected: false
                }
            })
            return list;
        }
    },
    watch: {
        'item.Name'(name: string) {
            this.keyword = name;
        },
        async item() {
            await this.search(this.item.UnitName);
            this.currentValue.Name = this.item.UnitShortName;
            if (this.item.UnitCode) {
                this.currentValue.Value = this.item.UnitCode
            }
            else if (this.list.length > 0) {
                let filteredList = this.list.filter((listItem) => listItem.Name?.toLowerCase() === this.item.UnitName.toLowerCase());

                if (filteredList.length !== 1) {
                    filteredList = this.list.filter((listItem) => listItem.ShortName?.toLowerCase() === this.item.UnitShortName.toLowerCase());
                }

                if (filteredList.length === 1) {
                    this.currentValue.Value = filteredList[0].Code || '';
                    this.item.UnitCode = this.currentValue.Value.toString();
                    this.$emit('select', this.item);
                }
            }
        }
    }
})
